module.exports = __webpack_public_path__ + "static/media/water-delivery-GIS-02.cee53a22.jpg";